import React from 'react';
import { ThreadInformation, ThreadInformationProps } from './ThreadInformation';

type ThreadInformationListProps = {
  threads: ThreadInformationProps[];
};

export function ThreadInformationList({ threads }: ThreadInformationListProps) {
  if (threads.length === 0) {
    return null;
  }
  return (
    <ul className="thread-list" aria-labelledby="thread-list-heading">
      {threads.map(thread => {
        return (
          <ThreadInformation
            key={thread.id + thread.activityCount}
            id={thread.id}
            createDate={thread.createDate}
            title={thread.title}
            pageLink={thread.pageLink}
            teaserText={thread.teaserText}
            author={thread.author}
            activityCount={thread.activityCount}
            lastActivityInfo={thread.lastActivityInfo}
            teaserImage={thread.teaserImage}
          />
        );
      })}
    </ul>
  );
}
